<template>
  <b-container fluid class="position-relative" style="min-height: 100vh">
    <div v-if="notForEdit && ($route.name !== 'AddNewCommissionShipment')">
      <b-badge variant="danger">В текущем статусе редактирование пакета невозможно.</b-badge>
    </div>
    <div
      v-if="($route.name === 'EditCommissionShipment') && (isNewPackageInChain()) && ($route.name !== 'AddNewCommissionShipment')">
      <decline-reasons :declineReasons="declineReasons"></decline-reasons>
    </div>
    <div class="d-flex justify-content-end" style="right: 11px; position: absolute;">
      <div v-if="hasCommissionshipmentFromDtRight()" class="px-2 d-flex align-items-end">
        <b-button
          squared
          variant="success"
          @click="loadFromDtModalShow = !loadFromDtModalShow"
          size="sm">
          Загрузить данные из ДТ
        </b-button>
      </div>
      <div v-if="isTransnord()">
        <b-form-file
          v-model="excelFile"
          :placeholder="'Загрузить из excel'"
          @change="browseFromExcel($event)"
          size="sm"
          accept=".xls, .xlsx">
        </b-form-file>
      </div>
    </div>
    <div v-if="isRefVisible" @click="closeRefs" class="close-ref"></div>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(sendToFts)" autocomplete="off">
        <b-tabs v-model="tabIndex" id="document-tabs" content-class="mt-3">
          <b-tab :active="i.active" v-for="i in tabs" :key="i.key">
            <template #title>
              {{ i.name }}
              <b-button-close @click="removeInventory" class="ml-3"
                              v-if="i.name === 'Опись документов'"></b-button-close>
            </template>
            <commission-page
              v-if="i.name === 'Поручение'"
              ref="commissionPage"
              :commissionShipmentDoc="commissionShipmentDoc"
              :notForEdit="notForEdit"
              @updateCommissionShipment="savePackageInIdb()"
              :getValidationState="getValidationState"
              :targetInput="targetInput"
              @closeRefs="closeRefs"
              @setVisible="isRefVisible = $event"
              @setTarget="targetInput = $event">
            </commission-page>
            <goods-page
              v-if="i.name === 'Товары'"
              ref="goodsPage"
              :commissionShipmentDoc="commissionShipmentDoc"
              :notForEdit="notForEdit"
              @updateCommissionShipment="savePackageInIdb()"
              :getValidationState="getValidationState">
            </goods-page>
            <inventory-page
              v-if="i.name === 'Опись документов'"
              ref="inventoryPage"
              :inventoryDoc="inventoryDoc"
              :DocSig_PersonName="DocSig_PersonName"
              :UsedDate="UsedDate"
              :notForEdit="notForEdit"
              @updateInventory="savePackageInIdb()"
              :getValidationState="getValidationState"
              @removeInventoryTab="removeInventory"
              @setTabIndex="tabIndex = 2"
              :targetInput="targetInput"
              @closeRefs="closeRefs"
              @setVisible="isRefVisible = $event"
              @setTarget="targetInput = $event">
            </inventory-page>
          </b-tab>
          <template #tabs-end>
            <b-nav-item v-if="tabs.length <= 2" role="presentation" @click.prevent="addInventory" href="#"><b>+ Добавить
              опись</b></b-nav-item>
          </template>
        </b-tabs>
        <b-row class="mb-3 mt-7">
          <b-col xl="6" lg="12" md="12" sm="12" cols="12">
            <div class="d-md-flex d-lg-flex align-items-center">
              <span v-b-tooltip.hover
                    :title="((!DocumentNumber || !DocumentDate) && !notForEdit) ? 'Необходимо указать номер и дату поручения' : notForEdit ? 'В текущем статусе изменение пакета невозможно' : ''">
                <b-button
                  variant="success"
                  @click="sendToPortal"
                  class="btn-action-success mr-3 mb-2"
                  :disabled="(!DocumentNumber || !DocumentDate) || notForEdit"
                  squared size="sm"
                >
                  Сохранить
                </b-button>
              </span>
              <span v-b-tooltip.hover :title="notForEdit ? 'В текущем статусе изменение пакета невозможно' : ''">
                <b-button
                  variant="success"
                  @click="scrollIfError"
                  class="btn-action-success mr-3 mb-2"
                  :disabled="notForEdit"
                  squared
                  size="sm"
                >
                Отправить&nbsp;в&nbsp;ФТС
              </b-button>
              </span>
              <div v-if="hasEmptyRequiredFields" class="mr-3 custom-invalid-feedback" style="height: 31px">Заполните
                обязательные поля на вкладках Поручение, Товары <span
                  v-if="$refs.inventoryPage && ($refs.inventoryPage.length > 0)">{{ ($refs.inventoryPage && ($refs.inventoryPage.length > 0)) ? ', Опись документов' : '' }}</span>
              </div>
              <b-form-checkbox
                id="ctspSwitch"
                v-model="CTSPIndicator"
                name="check-button"
                :value="1"
                :unchecked-value="0"
                switch>
                <span style="font-size: 14px">Отправить в КТСП после получения решения</span>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <b-modal ref="save-package-result-modal" @hidden="hideModal" hide-footer no-close-on-backdrop no-close-on-esc
             title="Данные успешно сохранены">
      <div class="d-block text-center">
        <span>Создан пакет №{{ $route.params.pid }}</span>
      </div>
      <b-button class="mt-3" variant="outline-primary" block @click="checkoutToEditCommissionShipment">Продолжить работу
        с пакетом
      </b-button>
      <b-button class="mt-2" variant="outline-success" block @click="() => $router.push('/packages')">Перейти к
        списку пакетов
      </b-button>
    </b-modal>
    <b-modal ref="get-packages-from-cache" hide-footer no-close-on-backdrop no-close-on-esc
             title="У вас есть несохраненные данные">
      <b-button class="mt-2" variant="primary" @click="$refs['get-packages-from-cache'].hide()" block>Отмена</b-button>
      <b-button class="mt-2" variant="outline-danger" @click="deletePackageFromIdb" block>Уйти с потерей данных
      </b-button>
    </b-modal>
    <b-modal
      v-model="loadFromDtModalShow"
      id="modalLoadFiles"
      size="lg"
      scrollable
      hide-footer
      :title="(desktop || largeDesktop) ? 'Загрузите ДТ таможенного формата' : 'Загрузите ДТ'">
      <file-upload-form
        :loading="docsLoading"
        @loadFiles="loadFiles"/>
    </b-modal>
  </b-container>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex'
  import CommissionPage from './CommissionPage'
  import GoodsPage from './GoodsPage'
  import InventoryPage from './InventoryPage'
  import FileUploadForm from '../../modals/FileUploadForm'
  import DeclineReasons from '../../../views/DeclineReasons'
  import idbapi from '../../../idbapi/idb.js'
  import {parseExcelMixin} from '../../mixins/parseExcelMixin'
  import moment from 'moment'

  export default {
    name: "CommissionShipmentForm",
    mixins: [parseExcelMixin],
    components: {
      CommissionPage,
      GoodsPage,
      InventoryPage,
      DeclineReasons,
      FileUploadForm
    },
    data () {
      return {
        CTSPIndicator: 0,
        DocumentNumber: null,
        DocumentDate: null,
        DocSig_PersonName: null,
        UsedDate: null,
        showAllDeclineReasons: false,
        tabIndex: 0,
        tabs: [
          { name: 'Поручение', key: Math.random() },
          { name: 'Товары', key: Math.random() }
        ],
        showConfirmModal: false,
        notForEdit: false,
        hasEmptyRequiredFields: false,
        idbPackageId: 1,
        preventedRouteTo: null,
        excelFile: null,
        targetInput: null,
        isRefVisible: false,
        loadFromDtModalShow: false,
        docsLoading: false
      }
    },
    watch: {
      '$route' (val, oldVal) {
        if (val.name === 'AddNewCommissionShipment') {
          this.$nextTick(() => {
            this.$refs.commissionPage[0].resetFormData()
            if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
              this.$refs.inventoryPage[0].resetFormData()
            }
            this.$refs.goodsPage[0].resetFormData()
          })
          this.setCommissionShipmentDoc(null)
          this.setInventoryDoc(null)
          this.setFreeBinaryDoc(null)
          this.setPackagePid({ pid: null })
          this.setPackageChainid({ chainid: null })
          this.setPackageStatus({ status: null })
          this.notForEdit = false
          this.setPackageDocumentsList(null)
        }
        if (val.name === 'EditCommissionShipment' && oldVal.name !== 'EditCommissionShipment' && oldVal.name !== 'AddNewCommissionShipment') {
          this.getPackageDocumentsList(val.params.pid).then(
            () => {
              if (this.isNewPackageInChain()) {
                this.setPackagePid({ pid: null })
              }
              this.getDocuments()
            },
            (error) => {
              console.log(error)
            }
          )
        }
        this.$nextTick(() => {
          this.$refs.observer.reset()
        })
      },
    },
    beforeRouteLeave (to, from, next) {
      this.preventedRouteTo = to.name
      if ((to.meta.prevented === false) || ((from.name === 'EditCommissionShipment') && (to.name !== 'Login'))) {
        idbapi.getPackageData().then(
          (documents) => {
            if (documents && (documents.length > 0)) {
              next(false)
              this.$refs['get-packages-from-cache'].show()
            } else {
              next()
            }
          }
        )
      } else {
        next()
      }
    },
    mounted () {
      if (this.$route.name === 'AddNewCommissionShipment') {
        this.setPackageDocumentsList(null)
        idbapi.getPackageData().then(
          (documents) => {
            if (documents && (documents.length > 0)) {
              if (documents[0].inventory !== null) {
                this.tabs.push({ name: 'Опись документов', key: Math.random() })
              }
              setTimeout(() => {
                this.addPackageDataFromIdb(documents)
              }, 0)
            }
          }
        )
      }
      this.$nextTick(() => {
        this.$refs.commissionPage[0].resetFormData()
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
          this.$refs.inventoryPage[0].resetFormData()
        }
        this.$refs.goodsPage[0].resetFormData()
        this.$refs.observer.reset()
      })
      if (this.$route.name === 'EditCommissionShipment') {
        this.getPackageDocumentsList(this.$route.params.pid).then(
          () => {
            if (!this.isEditedAsNewPackage()) {
              this.notForEdit = this.isPackageNotForEdit()
            }
            if (this.isNewPackageInChain() || this.isEditedAsNewPackage()) {
              this.setPackagePid({ pid: null })
            }
            if (this.isEditedAsNewPackage()) {
              this.setPackageChainid({ chainid: null })
              this.setPackageStatus({ status: null })
            }
            idbapi.getPackageData().then(
              (documents) => {
                if (documents && (documents.length > 0)) {
                  if (documents[0].inventory !== null) {
                    this.tabs.push({ name: 'Опись документов', key: Math.random() })
                  }
                  setTimeout(() => {
                    this.addPackageDataFromIdb(documents)
                  }, 200)
                } else {
                  this.getDocuments()
                }
              }
            )
          },
          (error) => {
            console.log(error)
          }
        )
      }
      this.$watch(
        () => {
          return this.$refs.commissionPage[0].commissionForm.DocumentNumber
        },
        (val) => {
          this.DocumentNumber = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.commissionPage[0].commissionForm.DocumentDate
        },
        (val) => {
          this.DocumentDate = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.commissionPage[0].commissionForm.DocSig_PersonName
        },
        (val) => {
          this.DocSig_PersonName = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.commissionPage[0].commissionForm.DocSig_IssueDate
        },
        (val) => {
          this.UsedDate = val
        }
      )
    },
    computed: {
      ...mapState(
        {
          packagePid: state => state.commissionShipment.packagePid,
          packageChainid: state => state.commissionShipment.packageChainid,
          packageStatus: state => state.commissionShipment.packageStatus,
          declineReasons: state => state.packages.declineReasons || JSON.parse(localStorage.getItem('decline_reasons')),
          commissionShipmentDoc: state => state.commissionShipment.commissionShipmentDoc,
          inventoryDoc: state => state.commissionShipment.inventoryDoc,
          packageDocumentsList: state => state.commissionShipment.packageDocumentsList,
          nsiCountries: state => state.commissionShipment.nsiCountries,
          nsiPorts: state => state.commissionShipment.nsiPorts,
          userInfo: state => state.authorization.userInfo,
          mobile: state => state.mobile,
          tablet: state => state.tablet,
          desktop: state => state.desktop,
          largeDesktop: state => state.largeDesktop
        }
      )
    },
    methods: {
      moment: function (date) {
        moment.locale('ru')
        return moment(date)
      },
      closeRefs () {
        for (const item in this.$refs.commissionPage[0].commissionForm) {
          if (this.$refs.commissionPage[0].$refs[item] && this.$refs.commissionPage[0].$refs[item].items) {
            this.$refs.commissionPage[0].$refs[item].items = []
          }
        }
        this.$refs.commissionPage[0].$refs['ACCOMPANYINGDOCUMENT_DocumentKind'].items = []
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
          for (let i = 0; i < this.$refs.inventoryPage[0].inventoryForm.InventDocument.INVENTDOCUMENT_ITEM.length; i++) {
            this.$refs.inventoryPage[0].$refs['InvDocCode-' + i][0].items = []
          }
        }
      },
      browseFromExcel (event) {
        this.$refs.goodsPage[0].COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM = []
        this.$refs.goodsPage[0].GoodsDescription = null
        this.$refs.commissionPage[0].resetFormData()
        this.parseExcelFile(event)
      },
      isTransnord () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'load_commissionshipment_from_excel_Transnord'
        })
        return (hasRights.length > 0)
      },
      isPackageNotForEdit () {
        let notForEdit = [94, 273, 266, 4, 6, 0].find((item) => {
          return item === parseInt(this.packageStatus)
        })
        return notForEdit === undefined
      },
      isEditedAsNewPackage () {
        return (this.$route.query.new === 'true')
      },
      isNewPackageInChain () {
        const isNewPackageInChain = [94, 273, 266, 4, 6].find((item) => {
          return item === parseInt(this.packageStatus)
        })
        return !!isNewPackageInChain
      },
      hasInventoryTab () {
        const hasInventory = this.tabs.find((item) => {
          return item.name === 'Опись документов'
        })
        return !!hasInventory
      },
      addInventory () {
        this.tabs.push({ name: 'Опись документов', key: Math.random() })
        setTimeout(() => {
          this.tabIndex = 2
          this.savePackageInIdb()
        }, 200)
      },
      removeInventory () {
        this.tabs.pop()
        setTimeout(() => {
          this.tabIndex = 1
          this.savePackageInIdb()
        }, 200)
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
          if (this.$refs.inventoryPage[0].inventoryForm.did) {
            this.deleteInventoryDoc({
              pid: this.$route.params.pid,
              did: this.$refs.inventoryPage[0].inventoryForm.did
            }).then(
              () => {
                this.$refs.inventoryPage[0].resetFormData()
              },
              (error) => {
                console.log(error)
              }
            )
          }
        }
      },
      async getDocuments () {
        function compare (a, b) {
          if (a.type < b.type) return -1
          if (a.type > b.type) return 1
          return 0
        }

        this.packageDocumentsList.documents.sort(compare)
        for (let i = 0; i < this.packageDocumentsList.documents.length; i++) {
          switch (this.packageDocumentsList.documents[i].type.toLowerCase()) {
            case 'commissionshipment.cfg.xml':
              await this.getCommissionShipmentDoc({
                pid: this.$route.params.pid,
                new: this.isEditedAsNewPackage()
              }).then(() => {
                this.CTSPIndicator = this.commissionShipmentDoc.data.CTSPIndicator
              })
              break
            case 'commissionshipment_inventory.cfg.xml':
              if (!this.hasInventoryTab()) {
                this.tabs.push({ name: 'Опись документов', key: Math.random() })
              }
              await this.getInventoryDoc({ pid: this.$route.params.pid, new: this.isEditedAsNewPackage() })
              break
            case 'freebinarydoc.cfg.xml':
              await this.getFreeBinaryDoc({
                pid: this.$route.params.pid,
                did: this.packageDocumentsList.documents[i].did,
                new: this.isEditedAsNewPackage()
              })
              break
          }
        }
      },
      scrollIfError () {
        this.$refs.observer.validate()
        setTimeout(() => {
          const fieldsWithErrors = this.$refs.observer.errors
          let fieldsNames = []
          for (const property in fieldsWithErrors) {
            if (fieldsWithErrors[property].length > 0) {
              fieldsNames.push(property)
            }
          }
          if (fieldsNames.length > 0) {
            fieldsNames = fieldsNames.join(', ')
            this.$bvToast.toast('Заполните: ' + fieldsNames + '!', {
              title: 'Не заполнено обязательное поле',
              toaster: 'b-toaster-bottom-right',
              solid: true,
              appendToast: true,
              noAutoHide: true
            })
          } else {
            this.sendToFts()
          }
        }, 500)
      },
      getValidationState ({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null
      },
      sendToPortal () {
        this.showConfirmModal = true
        this.savePackage()
      },
      sendToFts () {
        this.savePackage().then(
          () => {
            console.log(this.$route.params.pid)
            this.sendPackageFts(this.$route.params.pid).then(
              () => {
                this.$router.push('/packages')
              },
              error => {
                console.log(error)
              }
            )
          },
          error => {
            console.log(error)
          }
        )
      },
      getPackagePid () {
        // новый пакет в цепочке
        if ((this.packagePid === null) && this.isNewPackageInChain() && (this.$route.name === 'EditCommissionShipment') && !this.isEditedAsNewPackage()) {
          return null
        }
        // новый пакет
        if ((this.packagePid === null) && (this.packageStatus === null) && !(this.$route.name === 'EditCommissionShipment') && !this.isEditedAsNewPackage()) {
          return null
        }
        // текущий пакет
        if ((this.packagePid !== null) && (this.$route.name === 'EditCommissionShipment') && !this.isEditedAsNewPackage()) {
          return this.$route.params.pid
        }
        // новый пакет на основании предыдущего
        if (this.isEditedAsNewPackage()) {
          return null
        }
      },
      getPackageChanid () {
        // новый пакет в цепочке
        if ((this.packagePid === null) && this.isNewPackageInChain() && (this.$route.name === 'EditCommissionShipment') && !this.isEditedAsNewPackage()) {
          return this.packageChainid
        }
        // новый пакет
        if ((this.packagePid === null) && (this.packageStatus === null) && !(this.$route.name === 'EditCommissionShipment') && !this.isEditedAsNewPackage()) {
          return null
        }
        // текущий пакет
        if ((this.packagePid !== null) && (this.$route.name === 'EditCommissionShipment') && !this.isEditedAsNewPackage()) {
          return null
        }
        // новый пакет на основании предыдущего
        if (this.isEditedAsNewPackage()) {
          return null
        }
      },
      addPackageDataFromIdb (documents) {
        this.idbPackageId = documents[0].id
        this.setCommissionShipmentDoc({
          data: {
            data: documents[0].commissionShipment,
            did: documents[0].commissionShipment.did
          }
        })
        if (documents[0].inventory !== null) {
          this.setInventoryDoc({ data: { data: documents[0].inventory, did: documents[0].inventory.did } })
        }
      },
      deletePackageFromIdb () {
        idbapi.deletePackageData(this.idbPackageId)
        this.$refs['get-packages-from-cache'].hide()
        this.$router.push({ name: this.preventedRouteTo })
      },
      savePackageInIdb () {
        const commissionShipmentData = Object.assign(
          {},
          this.$refs.commissionPage[0].commissionForm,
          { COMMISSIONSHIPMENTGoods: this.$refs.goodsPage[0].COMMISSIONSHIPMENTGoods },
          { GoodsDescription: this.$refs.goodsPage[0].GoodsDescription },
          { TotalGrossWeightQuantity: this.$refs.goodsPage[0].TotalGrossWeightQuantity },
          { TotalNetWeightQuantity: this.$refs.goodsPage[0].TotalNetWeightQuantity },
          { TotalVolumeQuantity: this.$refs.goodsPage[0].TotalVolumeQuantity },
          { TotalPlacesQuantity: this.$refs.goodsPage[0].TotalPlacesQuantity },
        )
        let inventoryData = null
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
          inventoryData = this.$refs.inventoryPage[0].inventoryForm
        }
        idbapi.updatePackageData({
          id: this.idbPackageId,
          commissionShipment: commissionShipmentData,
          inventory: inventoryData,
          pid: (this.$route.params.pid) ? (this.$route.params.pid) : null,
          editedAsNew: this.isEditedAsNewPackage(),
          new: (this.$route.name === 'AddNewCommissionShipment'),
          edited: (this.$route.name === 'EditCommissionShipment'),
          type: 'commissionshipment'
        })
      },
      savePackage () {
        return new Promise((resolve, reject) => {
          const commissionShipmentData = Object.assign(
            {},
            this.$refs.commissionPage[0].commissionForm,
            { COMMISSIONSHIPMENTGoods: this.$refs.goodsPage[0].COMMISSIONSHIPMENTGoods },
            { GoodsDescription: this.$refs.goodsPage[0].GoodsDescription },
            { TotalGrossWeightQuantity: this.$refs.goodsPage[0].TotalGrossWeightQuantity },
            { TotalNetWeightQuantity: this.$refs.goodsPage[0].TotalNetWeightQuantity },
            { TotalVolumeQuantity: this.$refs.goodsPage[0].TotalVolumeQuantity },
            { TotalPlacesQuantity: this.$refs.goodsPage[0].TotalPlacesQuantity },
            { CTSPIndicator: this.CTSPIndicator }
          )
          let inventoryData = null
          if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
            inventoryData = this.$refs.inventoryPage[0].inventoryForm
          }
          this.saveCommissionShipment(commissionShipmentData).then(
            () => {
              if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
                this.saveInventory(inventoryData).then(
                  () => {
                    if (this.showConfirmModal) this.$refs['save-package-result-modal'].show()
                    resolve()
                  },
                  (error) => {
                    reject(error)
                  }
                )
              } else {
                if (this.showConfirmModal) this.$refs['save-package-result-modal'].show()
                resolve()
              }
            },
            (error) => {
              reject(error)
            }
          )
          idbapi.deletePackageData(this.idbPackageId)
        })
      },
      saveCommissionShipment (data) {
        return new Promise((resolve, reject) => {
          if (this.$refs.commissionPage[0].commissionForm.did === null) {
            this.createCommissionShipmentDoc({
              pid: this.getPackagePid(),
              chainid: this.getPackageChanid(),
              data: data
            }).then(
              (result) => {
                this.$refs.commissionPage[0].commissionForm.did = result.did
                if ((this.$route.name === 'AddNewCommissionShipment') || ((this.$route.name === 'EditCommissionShipment') && this.isNewPackageInChain()) || ((this.$route.name === 'EditCommissionShipment') && this.isEditedAsNewPackage())) {
                  this.$router.push(`/packages/commission-shipment/${this.packagePid}`)
                }
                resolve()
              },
              error => {
                reject(error)
              }
            )
          } else {
            this.editCommissionShipmentDoc({
              pid: this.getPackagePid(),
              chainid: this.getPackageChanid(),
              data: data
            }).then(
              () => {
                resolve()
              },
              error => {
                reject(error)
              }
            )
          }
        })
      },
      async saveFreeBinaryDocList () {
        const INVENTDOCUMENT_ITEM = this.$refs.inventoryPage[0].inventoryForm.InventDocument.INVENTDOCUMENT_ITEM
        for (let i = 0; i < INVENTDOCUMENT_ITEM.length; i++) {
          if ((INVENTDOCUMENT_ITEM[i].did === null) && (Object.keys(INVENTDOCUMENT_ITEM[i]).indexOf('freebinarydoc') !== -1) && (typeof(INVENTDOCUMENT_ITEM[i].freebinarydoc) === 'object')) {
            INVENTDOCUMENT_ITEM[i].freebinarydoc.DocName = INVENTDOCUMENT_ITEM[i].InvDocName
            INVENTDOCUMENT_ITEM[i].freebinarydoc.RegNum = INVENTDOCUMENT_ITEM[i].InvDocNumber
            INVENTDOCUMENT_ITEM[i].freebinarydoc.RegDate = INVENTDOCUMENT_ITEM[i].InvDocDate
            INVENTDOCUMENT_ITEM[i].freebinarydoc.ModeCode = INVENTDOCUMENT_ITEM[i].InvDocCode
            const freeBinaryDocData = {
              pid: this.getPackagePid(),
              chainid: this.getPackageChanid(),
              did: null,
              data: INVENTDOCUMENT_ITEM[i].freebinarydoc
            }
            await this.createFreeBinaryDoc(freeBinaryDocData).then(
              (result) => {
                INVENTDOCUMENT_ITEM[i].did = result.did
              },
              (error) => {
                console.log(error)
              }
            )
          } else if ((INVENTDOCUMENT_ITEM[i].did !== null) && (Object.keys(INVENTDOCUMENT_ITEM[i]).indexOf('freebinarydoc') !== -1) && (typeof(INVENTDOCUMENT_ITEM[i].freebinarydoc) === 'object')) {
            INVENTDOCUMENT_ITEM[i].freebinarydoc.DocName = INVENTDOCUMENT_ITEM[i].InvDocName
            INVENTDOCUMENT_ITEM[i].freebinarydoc.RegNum = INVENTDOCUMENT_ITEM[i].InvDocNumber
            INVENTDOCUMENT_ITEM[i].freebinarydoc.RegDate = INVENTDOCUMENT_ITEM[i].InvDocDate
            INVENTDOCUMENT_ITEM[i].freebinarydoc.ModeCode = INVENTDOCUMENT_ITEM[i].InvDocCode
            const freeBinaryDocData = {
              pid: this.getPackagePid(),
              chainid: this.getPackageChanid(),
              did: INVENTDOCUMENT_ITEM[i].did,
              data: INVENTDOCUMENT_ITEM[i].freebinarydoc
            }
            await this.editFreeBinaryDoc(freeBinaryDocData)
          }
        }
      },
      saveInventory (data) {
        return new Promise((resolve, reject) => {
          if (this.$refs.inventoryPage[0].inventoryForm.did === null) {
            this.saveFreeBinaryDocList().then(() => {
              this.createInventoryDoc({ pid: this.getPackagePid(), chainid: this.getPackageChanid(), data: data }).then(
                (result) => {
                  this.$refs.inventoryPage[0].inventoryForm.did = result.did
                  resolve()
                },
                (error) => {
                  reject(error)
                }
              )
            })
          } else {
            this.saveFreeBinaryDocList().then(() => {
              this.editInventoryDoc({ pid: this.getPackagePid(), chainid: this.getPackageChanid(), data: data }).then(
                () => {
                  resolve()
                },
                error => {
                  reject(error)
                }
              )
            })
          }
        })
      },
      hideModal () {
        this.showConfirmModal = false
        if (this.$route.name !== 'EditCommissionShipment') {
          this.$router.push(`/packages/commission-shipment/${this.packagePid}`)
        }
        if (this.$route.name === 'EditCommissionShipment') {
          this.getPackageDocumentsList(this.$route.params.pid).then(
            () => {
              if (this.isNewPackageInChain() || this.isEditedAsNewPackage()) {
                this.setPackagePid({ pid: null })
              }
              this.getDocuments()
            },
            (error) => {
              console.log(error)
            }
          )
        }
      },
      checkoutToEditCommissionShipment () {
        this.$refs['save-package-result-modal'].hide()
      },
      ...mapActions({
        createCommissionShipmentDoc: 'commissionShipment/createCommissionShipmentDoc',
        editCommissionShipmentDoc: 'commissionShipment/editCommissionShipmentDoc',
        getCommissionShipmentDoc: 'commissionShipment/getCommissionShipmentDoc',
        createInventoryDoc: 'commissionShipment/createInventoryDoc',
        editInventoryDoc: 'commissionShipment/editInventoryDoc',
        getInventoryDoc: 'commissionShipment/getInventoryDoc',
        deleteInventoryDoc: 'commissionShipment/deleteInventoryDoc',
        getPackageDocumentsList: 'commissionShipment/getPackageDocumentsList',
        sendPackageFts: 'commissionShipment/sendPackageFts',
        getFreeBinaryDoc: 'commissionShipment/getFreeBinaryDoc',
        createFreeBinaryDoc: 'commissionShipment/createFreeBinaryDoc',
        editFreeBinaryDoc: 'commissionShipment/editFreeBinaryDoc',
        loadNsiCountries: 'commissionShipment/loadNsiCountries',
        loadNsiPorts: 'commissionShipment/loadNsiPorts',
        loadDt: 'commissionShipment/loadDt'
      }),
      ...mapMutations({
        setCommissionShipmentDoc: 'commissionShipment/setCommissionShipmentDoc',
        setInventoryDoc: 'commissionShipment/setInventoryDoc',
        setFreeBinaryDoc: 'commissionShipment/setFreeBinaryDoc',
        setPackagePid: 'commissionShipment/setPackagePid',
        setPackageChainid: 'commissionShipment/setPackageChainid',
        setPackageStatus: 'commissionShipment/setPackageStatus',
        setPackageDocumentsList: 'commissionShipment/setPackageDocumentsList',
        setNsiCountries: 'commissionShipment/setNsiCountries',
        setNsiPorts: 'commissionShipment/setNsiPorts'
      }),
      loadFiles (files) {
        this.docsLoading = true
        this.loadDt(files).then(
          (result) => {
            this.docsLoading = false
            this.$router.push(`/packages/commission-shipment/${result.pid}`)
            this.$root.$emit('bv::hide::modal', 'modalLoadFiles', event)
            this.hideModal()
          }),
          (error) => {
            this.docsLoading = false
            console.log(error)
          }
      },
      hasCommissionshipmentFromDtRight () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'load_commissionshipment_from_dt'
        })
        return (hasRights.length > 0)
      },
    },
    beforeDestroy () {
      this.setCommissionShipmentDoc(null)
      this.setInventoryDoc(null)
      this.setFreeBinaryDoc(null)
      this.setPackagePid({ pid: null })
      this.setPackageChainid({ chainid: null })
      this.setPackageStatus({ status: null })
      localStorage.removeItem('decline_reasons')
      this.notForEdit = false
      this.setPackageDocumentsList(null)
    }
  }
</script>

<style lang="scss" scoped>
  .custom-invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e7161a;
  }

  .close-ref {
    height: 100%;
    width: 100%;
    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    background-color: transparent;
    /* background-color: #989fa4; */
  }
</style>
